module.exports = __webpack_public_path__ + "static/1-da39b481e8d9a7d41fc65aa4f053fd55.jpg";